var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useFetch from '../useFetch';
import buildGraphQLQuery from './buildGraphQLQuery';
import checkSufficientQueryParams from './checkSufficientQueryParams';
var fetchConfigSettings = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
};
var useGraphQL = function (queryName, queryParams, _a) {
    var url = _a.url, fetchConfig = _a.fetchConfig;
    var areParamsSufficient = checkSufficientQueryParams(queryName, queryParams);
    var fetchParams = {
        url: url,
        fetchConfig: __assign(__assign({}, fetchConfigSettings), fetchConfig),
        body: {
            query: "{" + buildGraphQLQuery(queryName, __assign({}, queryParams)) + "}",
        },
    };
    return __assign({ areParamsSufficient: areParamsSufficient }, useFetch(__assign({}, fetchParams)));
};
export default useGraphQL;
//# sourceMappingURL=index.js.map